(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-menu"] && !Shopify.designMode) return;
  try {
    class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  // Tertiary Link Dropdown Functionality
  class TertiaryLinkDropdown extends HTMLElement {
    constructor() {
      super();
      this.trigger = this.querySelector('.tertiary-link-trigger');
      this.menu = this.querySelector('.tertiary-menu');
      this.container = this.closest('.tertiary-link-wrapper');
      this.isOpen = false;
      this.timer = false;

      this.trigger.addEventListener('click', this.toggleMenu.bind(this));
      document.addEventListener('click', this.handleClickOutside.bind(this));
      // On hover, open the menu, but do not close on mouseleave
      this.trigger.addEventListener('mouseenter', this.openMenu.bind(this));
      // Add mouseleave to trigger and menu for closing when mouse leaves both
      this.trigger.addEventListener('mouseleave', this.handleMouseLeave.bind(this));
      this.menu.addEventListener('mouseleave', this.handleMouseLeave.bind(this));
      this.trigger.addEventListener('mouseenter', this.handleMouseEnter.bind(this));
      this.menu.addEventListener('mouseenter', this.handleMouseEnter.bind(this));
      this._closeTimeout = null;
    }

    toggleMenu() {
      this.isOpen = !this.isOpen;
      this.trigger.setAttribute('aria-expanded', this.isOpen);
      this.menu.hidden = !this.isOpen;
    }

    openMenu() {
      this.isOpen = true;
      this.trigger.setAttribute('aria-expanded', true);
      this.menu.hidden = false;
    }

    closeMenu() {
      this.isOpen = false;
      this.trigger.setAttribute('aria-expanded', false);
      this.menu.hidden = true;
    }

    handleMouseLeave() {
      // Start a short timeout to close, in case mouse enters the other element
      this._closeTimeout = setTimeout(() => {
        this.closeMenu();
      }, 150);
    }

    handleMouseEnter() {
      // Cancel any pending close
      if (this._closeTimeout) {
        clearTimeout(this._closeTimeout);
        this._closeTimeout = null;
      }
    }

    handleClickOutside(event) {
      if (!this.contains(event.target)) {
        this.closeMenu();
      }
    }
  }

  if (!customElements.get('tertiary-link-dropdown')) {
    customElements.define('tertiary-link-dropdown', TertiaryLinkDropdown);
  }
  } catch(e) { console.error(e); }
})();

})();
